import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { EnumValidValueItemModel } from '../../../../models/enum/enum-valid-value-item.model';
import { NoteCategoryDataModel } from '../../../../models/notes/note-category-data.model';
import { NoteTypeDataModel } from '../../../../models/notes/note-type-data.model';
import {MatCheckbox} from '@angular/material/checkbox';

@Component({
  selector: 'app-tdo-notes-multiselect-menu',
  templateUrl: './tdo-notes-multiselect-menu.component.html',
  styleUrls: ['./tdo-notes-multiselect-menu.component.scss']
})
export class TdoNotesMultiselectMenuComponent implements OnInit {
  @Input() type: string;
  @Input() maxHeight: number = 222;
  @Input() selectableItems: EnumValidValueItemModel[];
  @Input() categoryValues: NoteCategoryDataModel[] = []; // Asegúrate de que se inicialice como un array
  @Input() typeValues: NoteTypeDataModel[] = []; // Asegúrate de que se inicialice como un array
  @Input() tooltip: string;
  @Input() noteId: string;
  @Input() isShowAllSelectors: boolean = true;

  @Output() categorySelectionComplete = new EventEmitter<NoteCategoryDataModel[]>();
  @Output() typeSelectionComplete = new EventEmitter<NoteTypeDataModel[]>();

  // Track selected categories/types
  selectedCategories: NoteCategoryDataModel[] = [];
  selectedTypes: NoteTypeDataModel[] = [];

  ngOnInit() {
    // Inicializar selectedCategories y selectedTypes con los valores de entrada
    this.selectedCategories = [...this.categoryValues];
    this.selectedTypes = [...this.typeValues];
  }

  isCategorySelected(item: EnumValidValueItemModel): boolean {
    return this.selectedCategories.some(cat => cat.enumNoteCategoryID === item.ValidValueItemId);
  }

  isTypeSelected(item: EnumValidValueItemModel): boolean {
    return this.selectedTypes.some(type => type.enumNoteTypeID === item.ValidValueItemId);
  }

  onCategoryClicked(item: EnumValidValueItemModel) {
    const index = this.selectedCategories.findIndex(cat => cat.enumNoteCategoryID === item.ValidValueItemId);
    if (index > -1) {
      this.selectedCategories.splice(index, 1); // Unselect category
    } else {
      const newCategory = new NoteCategoryDataModel();
      newCategory.NoteId = this.noteId;
      newCategory.enumNoteCategoryID = item.ValidValueItemId;
      newCategory.enumNoteCategory = item;
      this.selectedCategories.push(newCategory); // Select category
    }

    // Emit updated categories to the parent component
    this.categorySelectionComplete.emit([...this.selectedCategories]);
  }

  onTypeClicked(item: EnumValidValueItemModel) {
    const index = this.selectedTypes.findIndex(type => type.enumNoteTypeID === item.ValidValueItemId);
    if (index > -1) {
      this.selectedTypes.splice(index, 1); // Unselect type
    } else {
      const newType = new NoteTypeDataModel();
      newType.NoteId = this.noteId;
      newType.enumNoteTypeID = item.ValidValueItemId;
      newType.enumNoteType = item;
      this.selectedTypes.push(newType); // Select type
    }

    // Emit updated types to the parent component
    this.typeSelectionComplete.emit([...this.selectedTypes]);
  }

  onAllCategoriesClick(event: any) {
    if (event.checked) {
      this.selectedCategories = this.selectableItems.map(item => {
        const newCategory = new NoteCategoryDataModel();
        newCategory.NoteId = this.noteId;
        newCategory.enumNoteCategoryID = item.ValidValueItemId;
        newCategory.enumNoteCategory = item;
        return newCategory;
      });
    } else {
      this.selectedCategories = [];
    }
    this.categorySelectionComplete.emit(this.selectedCategories);
  }

  onAllTypesClick(event: any) {
    if (event.checked) {
      this.selectedTypes = this.selectableItems.map(item => {
        const newType = new NoteTypeDataModel();
        newType.NoteId = this.noteId;
        newType.enumNoteTypeID = item.ValidValueItemId;
        newType.enumNoteType = item;
        return newType;
      });
    } else {
      this.selectedTypes = [];
    }
    this.typeSelectionComplete.emit(this.selectedTypes);
  }

  clearCheckboxes(): void {
    // Clear category and type selections
    this.selectedCategories = [];
    this.selectedTypes = [];
    
    // Emit the empty values
    this.categorySelectionComplete.emit(this.selectedCategories);
    this.typeSelectionComplete.emit(this.selectedTypes);
  }
}
